import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EChartsOption } from 'echarts';
import { MeritorService } from './meritor.service';

@Component({
  selector: 'app-meritor',
  templateUrl: './meritor.component.html',
  styleUrls: ['./meritor.component.scss'],
})
export class MeritorComponent implements OnInit {
  selectedBtn: string = 'sales';
  selectedDi: string = 'All';
  selectedValues: any = {};
  formDetails: any = {};
  salesByRegion: any = {};
  algorithm: any = {};
  baseUrl: string = '';
  title: string = '';
  salesReal: any = {};
  top5: any = {};
  qParam: any = {};
  dataLoaded: boolean = false;
  top5Loaded: boolean = false;
  reset: number = 0;
  currentFilter: string = '';
  radio: any;
  chartDataEngineModel: any = {};
  chartDataCertification: any = {};
  chartDataEcc: any = {};
  chartDataParts: any = {};
  salesByDw3Digit: any = {};
  salesByDw1Digit: any = {};
  byCountryChart: boolean = false;
  // byDw3DigitChart: boolean = false;
  byDw1DigitChart: boolean = true;
  constructor(private service: MeritorService, private router: Router) {
    this.title = 'meritor';
    this.baseUrl = '/nrp/meritor/';
  }

  option: EChartsOption = {};

  activeButton: 'byRegion' | 'top5' = 'byRegion';
  setActiveButton(buttonName: 'byRegion' | 'top5') {
    this.activeButton = buttonName;
  }

  private normalizeMulti(value: any): string[] {
    if (!Array.isArray(value) || value.length === 0) return ['All'];
    return value;
  }

  ngOnInit(): void {
    this.selectedValues['product_group'] = ['All'];
    this.selectedValues['channel'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['bill_to_name'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['main_region'] = ['All'];
    this.selectedValues['part_number'] = ['All'];

    this.qParam = {
      product_group: this.normalizeMulti(this.selectedValues.product_group),
      channel: this.normalizeMulti(this.selectedValues.channel),
      certification: this.normalizeMulti(this.selectedValues.certification),
      bill_to_name: this.normalizeMulti(this.selectedValues.bill_to_name),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      part_number: this.normalizeMulti(this.selectedValues.part_number),
    };
    this.searchFilters();
    this.getSalesByRegion();
    this.getSalesRealization();
    this.getAlgorithms();
    this.getSalesByDw1Digit();
  }
  searchFilters() {
    let productGroup = {
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
    };
    let channel = {
      product_group: this.selectedValues.product_group,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
    };

    let customerGroup = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
    };
    let productCategory = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
    };
    let DDSPDCOthers = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
    };
    let main_region = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      part_number: this.selectedValues.part_number,
    };
    let part_number = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
    };

    if (this.currentFilter != 'product_group') {
      productGroup['current_dropdown'] = 'product_group';
      this.getDropdowndetails(productGroup);
    }

    if (this.currentFilter != 'channel') {
      channel['current_dropdown'] = 'channel';
      this.getDropdowndetails(channel);
    }

    if (this.currentFilter != 'certification') {
      customerGroup['current_dropdown'] = 'certification';
      this.getDropdowndetails(customerGroup);
    }

    if (this.currentFilter != 'bill_to_name') {
      productCategory['current_dropdown'] = 'bill_to_name';
      this.getDropdowndetails(productCategory);
    }

    if (this.currentFilter != 'ecc') {
      DDSPDCOthers['current_dropdown'] = 'ecc';
      this.getDropdowndetails(DDSPDCOthers);
    }

    if (this.currentFilter != 'main_region') {
      main_region['current_dropdown'] = 'main_region';
      this.getDropdowndetails(main_region);
    }

    if (this.currentFilter != 'part_number') {
      part_number['current_dropdown'] = 'part_number';
      this.getDropdowndetails(part_number);
    }
  }
  getDropdowndetails(type) {
    this.service
      .getMeritorDropDowns(type, this.baseUrl + 'dropdown')
      .subscribe((results) => {
        let channel: any[] = [];
        if (type.current_dropdown == 'product_group')
          channel = results.product_group;
        if (type.current_dropdown == 'channel') channel = results.channel;
        if (type.current_dropdown == 'certification')
          channel = results.certification;
        if (type.current_dropdown == 'bill_to_name')
          channel = results.bill_to_name;
        if (type.current_dropdown == 'ecc') channel = results.ecc;
        if (type.current_dropdown == 'main_region')
          channel = results.main_region;
        if (type.current_dropdown == 'part_number')
          channel = results.part_number;

        const resp = [...new Set(channel)];
        if (type.current_dropdown == 'product_group') {
          this.formDetails['product_group'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'channel') {
          this.formDetails['channel'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'certification') {
          this.formDetails['certification'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'bill_to_name') {
          this.formDetails['bill_to_name'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'ecc') {
          this.formDetails['ecc'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'main_region') {
          this.formDetails['main_region'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'part_number') {
          this.formDetails['part_number'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        this.formDetails = { ...this.formDetails };
      });
  }
  searchSalesData(event) {
    this.currentFilter = event.type;
    this.dataLoaded = false;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.qParam = {
      product_group: this.normalizeMulti(this.selectedValues.product_group),
      channel: this.normalizeMulti(this.selectedValues.channel),
      certification: this.normalizeMulti(this.selectedValues.certification),
      bill_to_name: this.normalizeMulti(this.selectedValues.bill_to_name),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      part_number: this.normalizeMulti(this.selectedValues.part_number),
    };
    this.searchFilters();
    this.getSalesByRegion();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    }
    if (this.selectedDi !== 'All') {
      this.searchDimension(this.selectedDi);
    }
    this.getAlgorithms();
  }
  getAlgorithms() {
    this.dataLoaded = false;
    this.service
      .getAlgorithm(this.qParam, this.baseUrl + 'algorithm')
      .subscribe((results) => {
        this.algorithm = results;
        this.dataLoaded = true;
      });
  }
  getSalesByRegion() {
    this.salesByRegion = [];
    this.top5Loaded = false;

    this.service
      .getSalesBy(this.qParam, this.baseUrl + 'sale/country')
      .subscribe((results) => {
        this.salesByRegion = results;
        this.top5Loaded = true;
      });
  }
  getSalesByDw3Digit() {
    this.salesByDw3Digit = [];
    this.top5Loaded = false;

    this.service
      .getSalesBy(this.qParam, this.baseUrl + 'sale/ecc')
      .subscribe((results) => {
        this.salesByDw3Digit = results;
        this.top5Loaded = true;
      });
  }
  getSalesByDw1Digit() {
    this.salesByDw1Digit = [];
    this.top5Loaded = false;

    this.service
      .getSalesBy(this.qParam, this.baseUrl + 'sale/ecc_major')
      .subscribe((results) => {
        this.salesByDw1Digit = results;
        this.top5Loaded = true;
      });
  }
  getSalesRealization() {
    this.salesReal = [];
    this.dataLoaded = false;

    this.service
      .getSalesRealization(this.qParam, this.baseUrl + 'salesrealisation')
      .subscribe((results) => {
        this.salesReal = results;
        this.dataLoaded = true;
      });
  }

  salesButton() {
    this.selectedBtn = 'sales';
    this.getSalesRealization();
  }
  marginButton() {
    this.selectedBtn = 'margin';
  }
  dailyButton() {
    this.selectedBtn = 'daily';
  }
  byCountry() {
    this.byCountryChart = true;
    this.byDw1DigitChart = false;
    // this.byDw3DigitChart = false;
    this.selectedDi = 'All';
    this.radio = null;
    this.qParam.country = ['All'];
    // this.qParam.ecc = ['All'];
    this.qParam.ecc_major = ['All'];
    this.getSalesByRegion();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    }
  }
  byDw3Digit() {
    // this.byDw3DigitChart = true;
    this.byCountryChart = false;
    this.byDw1DigitChart = false;
    this.selectedDi = 'All';
    this.radio = null;
    this.qParam.country = ['All'];
    this.qParam.ecc = ['All'];
    this.qParam.ecc_major = ['All'];
    this.getSalesByDw3Digit();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    }
  }
  byDw1Digit() {
    this.byDw1DigitChart = true;
    this.byCountryChart = false;
    // this.byDw3DigitChart = false;
    this.selectedDi = 'All';
    this.radio = null;
    this.qParam.country = ['All'];
    // this.qParam.ecc = ['All'];
    this.qParam.ecc_major = ['All'];
    this.getSalesByDw1Digit();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    }
  }
  searchDimension(event) {
    this.qParam = {
      product_group: this.normalizeMulti(this.selectedValues.product_group),
      channel: this.normalizeMulti(this.selectedValues.channel),
      certification: this.normalizeMulti(this.selectedValues.certification),
      bill_to_name: this.normalizeMulti(this.selectedValues.bill_to_name),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      part_number: this.normalizeMulti(this.selectedValues.part_number),
    };
    this.selectedDi = event;
    this.top5Loaded = false;
    this.top5 = [];

    this.service
      .getTop5(this.qParam, this.baseUrl + 'sales/top5/' + event)
      .subscribe((results) => {
        this.top5 = results;
        this.top5Loaded = true;
      });

    // const events = ['engine_model', 'certification', 'ecc', 'part_number']; // The events you want to pass

    // // Map over your events to create an array of observables
    // const observables = events.map(event =>
    //   this.service.getTop5(this.qParam, this.baseUrl + 'sales/top5/' + event)
    // );
    // this.chartDataEngineModel = [];
    // this.chartDataCertification = [];
    // this.chartDataEcc = [];
    // this.chartDataParts = [];

    // // Use forkJoin to execute all observables in parallel
    // forkJoin(observables).subscribe(results => {
    //   // Assuming you want to store the results in four separate variables
    //   [this.chartDataEngineModel, this.chartDataCertification, this.chartDataEcc, this.chartDataParts] = results;

    //   // Set your loaded flags or perform other actions after all data is loaded
    //   this.top5Loaded = true;
    // });

    this.byDw1DigitChart = false;
    this.byCountryChart = false;
  }

  selectedDiamension(event) {}
  resetFilter(event) {
    this.reset = this.reset + 1;
    this.selectedValues['product_group'] = ['All'];
    this.selectedValues['channel'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['bill_to_name'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['main_region'] = ['All'];
    this.selectedValues['part_number'] = ['All'];

    this.qParam = {
      product_group: ['All'],
      channel: ['All'],
      certification: ['All'],
      bill_to_name: ['All'],
      ecc: ['All'],
      main_region: ['All'],
      part_number: ['All'],
    };
    this.currentFilter = '';
    this.searchFilters();
    this.byDw1Digit();
    this.getAlgorithms();
  }
  onChartClick(event) {
    let qParam = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      part_number: this.selectedValues.part_number,
      ecc_major: this.qParam.ecc_major,
      country: this.qParam.country,
      part: this.title,
      flag: 'nrp',
      subModule: 'ctt',
    };
    if (event.name === 'Price\nImpact') {
      qParam['property'] = 'price';
      qParam['title'] = 'Pure Price Impact';
    }
    if (event.name === 'Mix\nImpact') {
      qParam['property'] = 'mix_sales';
      qParam['title'] = 'Price Mix Impact';
    }
    if (event.name === 'Volume\nImpact') {
      qParam['property'] = 'volume_sales';
      qParam['title'] = 'Volume Impact';
    }
    if (event.name === 'Acquisition') {
      qParam['property'] = 'acquisition_sales';
      qParam['title'] = 'Acquisition';
    }
    if (event.name === 'Attrition') {
      qParam['property'] = 'attrition_sales';
      qParam['title'] = 'Attrition';
    }
    if (event.name === 'Brand\nMix') {
      qParam['property'] = 'brand_mix_sales';
      qParam['title'] = 'Brand\nMix';
    }
    if (event.name === 'Forex\nImpact') {
      qParam['property'] = 'forex_sales';
      qParam['title'] = 'Forex Impact';
    }
    if (
      event.value !== 0 &&
      event.name !== '2025' &&
      event.name !== '2026' &&
      event.name !== '2025 YTD\ndemand' &&
      event.name !== '2026 YTD\ndemand'
    ) {
      this.router.navigate(['/components/meritor/detailedMeritorView'], {
        queryParams: qParam,
      });
    }
  }
  legendClickByRegion(event) {
    if (this.selectedBtn == 'daily') {
      this.qParam.country = [event];
      // this.qParam.country = null;
    } else {
      this.qParam.country = [event];
      if (this.selectedBtn == 'sales') {
        this.getSalesRealization();
      }

      this.getAlgorithms();
    }
  }
  legendClickByDw1Digit(event) {
    if (this.selectedBtn == 'daily') {
      this.qParam.ecc_major = [event];
      // this.qParam.product_group = null;
    } else {
      this.qParam.ecc_major = [event];
      if (this.selectedBtn == 'sales') {
        this.getSalesRealization();
      }

      this.getAlgorithms();
    }
  }
  legendClickByDw3Digit(event) {
    if (this.selectedBtn == 'daily') {
      this.qParam.ecc = [event];
      // this.qParam.product_group = null;
    } else {
      this.qParam.ecc = [event];
      if (this.selectedBtn == 'sales') {
        this.getSalesRealization();
      }

      this.getAlgorithms();
    }
  }

  top5ButtonClicks(){
    // this.byDw1DigitChart = false;
    // this.byCountryChart = false;
  }
}
